import React from "react";
import "../styles/MarketPlace.css";
import {
  FaClock,
  FaShoppingCart,
  FaTruck,
  FaFilter,
  FaCreditCard,
  FaMobileAlt,
  FaTools,
  FaStar,
  FaHeadset,
  FaWhatsapp
} from "react-icons/fa";

const offers = [
  { icon: <FaClock />, title: "LIVE STOCKLIST", description: "Access entire stock online 24/7. Get notified of inventory updates as it happens." },
  { icon: <FaShoppingCart />, title: "ON-DEMAND BUYING", description: "Automated checkout using Buy It Now prices or ability to make offers." },
  { icon: <FaTruck />, title: "NEXT DAY SHIPPING", description: "No waiting weeks for your phones to ship. Most orders ship next business day." },
  { icon: <FaFilter />, title: "BROWSE BY ATTRIBUTE", description: "Wide range of grades and cosmetic conditions, segmented by fully functional, functional fail, and level of damage." },
  { icon: <FaCreditCard />, title: "EASY PAYMENT OPTIONS", description: "We offer flexible and easy payment options such as Wire, ACH, and PayPal." },
  { icon: <FaMobileAlt />, title: "RELIABLE SOURCE", description: "150k – 200k devices are processed monthly from all three top US mobile carriers and other high-quality sources." },
  { icon: <FaTools />, title: "READY FOR REPAIR", description: "Are you a repair store and specialize in repairing screens and cameras? We have devices for you." },
  { icon: <FaStar />, title: "ECOMM QUALITY", description: "Extensive functional testing and excellent cosmetic quality. Apple devices have battery health greater than 80%." },
  { icon: <FaHeadset />, title: "AFTER-SALE SUPPORT", description: "Dedicated sales & support team available via call, email, or WhatsApp to assist you." }
];

const MarketPlace = () => {
  return (
    <>
      <div id="marketplace" className="marketplace-container">
        <div className="marketplace-content">
          <div className="text-content">
            <h1 className="title">BRANDS WE WORK WITH TO READY MOBILE DEVICES AT WHOLESALE PRICES.</h1>
            <p className="description">
              Direct sourcing from all three of the top US mobile carriers and top insurance companies, ensuring you have access to a wide variety of phones with unbeatable quality at wholesale prices.
            </p>
            <button className="cta-button">
              <a href="https://bhanottrade.com/contact" className="text-decoration-none text-light">SIGN UP TODAY</a>
            </button>
          </div>
          <div className="logo-container">
            <img src="/assets/tmobile.jpg" alt="T-Mobile" className="partner-logo" />
            <img src="/assets/verizon.jpg" alt="Verizon" className="partner-logo" />
            <img src="/assets/attb.png" alt="AT&T" className="partner-logo" />
            <img src="/assets/rocketdrops.png" alt="RocketDrop" className="partner-logo" />
          </div>
        </div>
      </div>

      <section className="offers-container text-light">
        <h2 className="offers-title">BHANOT MARKETPLACE OFFERS</h2>
        <div className="offers-grid">
          {offers.map((offer, index) => (
            <div className="offer-card" key={index}>
              <div className="offer-icon">{offer.icon}</div>
              <h3 className="offer-title">{offer.title}</h3>
              <p className="offer-description">{offer.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="marketplace-section d-flex align-items-center justify-content-center text-center">
        <div className="container">
          <h1 className="marketplace-title2">
            WHETHER YOU'RE A REPAIR STORE OR AN ECOMMERCE BUYER
          </h1>
          <p className="marketplace-subtitle text-light">
            You’ll find the perfect mobile phones at the perfect prices to grow your business.
          </p>
          <a href="https://bhanottrade.com/contact">
            <button className="btn btn-primary btn-lg">SIGN UP TODAY</button>
          </a>

        </div>
      </section>

      <section className="contact-section text-center">
        <h2 className="contact-title">CONTACT US</h2>
        <div className="container">
          <div className="row justify-content-center">
            {/* Contact Card 1 - Shubham Jangra */}
            <div className="col-md-4">
              <div className="contact-card text-center">
                <a
                  href="https://wa.me/971522294184"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp size={60} className="mb-3 text-success" />
                </a>
                <h5 className="contact-name">Bhanot International</h5>
                <h6 className="contact-name">Overseas Empire</h6>
                <p className="mt-2">+995 504 22 03 83</p>
              </div>
            </div>

            {/* Contact Card 2 - Viktoria Bolkvadze */}
            <div className="col-md-4">
              <div className="contact-card text-center">
                <a
                  href="https://wa.me/995504220383"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp size={60} className="mb-3 text-success" />
                </a>                
                <h5 className="contact-name">Viktoria Bolkvadze</h5>
                <h6 className="contact-name">Sales Head</h6>
                <p className="mt-2">+995 504 220 383</p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default MarketPlace;